import React, { useState } from "react";
import { Stack } from "@fluentui/react";
import { Button } from "@fluentui/react-components";

export const DateComponent = (props:any) => {
    const [selected, setSelected] = useState(props.latest);
    
        const handleYesClick = () => {
            setSelected("latest")
                props.setIsLatest(true);
            };
        const handleNoClick = () => {
            setSelected("range");
            props.setIsLatest(false);
        }
    
        return (
            <Stack horizontal tokens={{ childrenGap: 10 }}>
                {selected === "latest" ? (
                    <Button shape="circular" size='small' disabled={props.disabled} appearance="primary" onClick={handleYesClick}>Latest</Button>
                ) : (
                    <Button shape="circular" size='small' disabled={props.disabled} style={{fontSize:'12'}} onClick={handleYesClick}>Latest</Button>
                )}
                {selected === "range" ? (
                    <Button shape="circular" size='small' disabled={props.disabled} appearance="primary" onClick={handleNoClick}>Range</Button>
                ) : (
                    <Button shape="circular" size='small' disabled={props.disabled} onClick={handleNoClick}>Range</Button>
                )}
            </Stack>
        );
}